export default "__VITE_ASSET__CQsW_$Xz__"